module.exports = __webpack_public_path__ + "static/media/ic_outlet_status_change.6e88500b.svg";